import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55ba3b00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title sub-title" }, "URL", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" お知らせいただいたURLに国立国会図書館がアクセスをして収集対象であることを確認した場合に、国立国会図書館の収集プログラムを用いて収集（ファイルの複製）をします。詳しくは ")
const _hoisted_4 = {
  href: "https://dl.ndl.go.jp/html-resources/url_nyuryoku.pdf",
  target: "_blank"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 「URLの入力方法」 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" をご覧ください。 ")
const _hoisted_7 = { class: "table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _hoisted_3,
      _createElementVNode("a", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_DssIcon, {
          icon: "file-pdf",
          label: 'pdf'
        })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("table", _hoisted_7, [
      _createElementVNode("tbody", null, [
        _hoisted_8,
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.pageUrl,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.pageUrl) = $event)),
          name: '掲載ページのURL',
          description: 'コンテンツファイル（PDF、EPUB、DAISY等）を掲載しているページのURLを入力してください。複数ある場合は改行して入力してください。',
          required: true,
          id: 'pageUrl',
          textarea: true,
          requiredCheck: _ctx.props.requiredCheck
        }, null, 8, ["modelValue", "requiredCheck"]),
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.fileUrl,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.fileUrl) = $event)),
          name: 'コンテンツファイルのURL',
          description: 'コンテンツファイル（PDF、EPUB、DAISY等）そのもののURLを入力してください。複数ある場合は改行して入力するか、一つだけ入力して末尾に「等」と加えてください。',
          required: true,
          id: 'fileUrl',
          textarea: true,
          requiredCheck: _ctx.props.requiredCheck
        }, null, 8, ["modelValue", "requiredCheck"])
      ])
    ])
  ]))
}